import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../common/Button';

function CircleButton({ label, onSelect }) {
  return (
    <div className="mb-3">
      <Button
        key={label}
        name={label}
        label={label}
        onClick={onSelect}
        cssClass="btn btn-circle"
      />
    </div>
  );
}

CircleButton.propTypes = {
  label: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};
CircleButton.defaultProps = {};

export default CircleButton;
